import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=46988605&scoped=true&"
import script from "./UserAdd.vue?vue&type=script&lang=js&"
export * from "./UserAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=46988605&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46988605",
  null
  
)

export default component.exports